const styles = (theme) => ({
  pill: {
    borderRadius: 10,
    background: '0% 0% no-repeat padding-box',
    padding: theme.spacing(0.3, 2),
    font: '12px neuzeit-grotesk',
    fontWeight: 'bold',
    display: 'inline-block',
    margin: theme.spacing(0, 0.25),
  },
  info: {
    backgroundColor: theme.color.teal_1F,
    color: theme.color.teal,
  },
  warning: {
    backgroundColor: theme.color.yellow_00,
    color: theme.color.white,
  },
  error: {
    backgroundColor: theme.color.pink,
    color: theme.color.white,
  },
  addMargin: {
    marginBottom: 6,
  },
});

export default styles;
